import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenertedLinkedinService {
  mainURL = 'api/';
  constructor(private http: HttpClient) {}

  getGeneratedLinkedins() {
    return this.http.get(environment.apiUrl + this.mainURL + 'enhanced-linkedins');
  }
}